import { useEffect } from 'react';
import { useTranslate } from './context/useTranslate';
import { useLocation } from 'react-router-dom';
import { useCfgParam } from './useCfgParam';
import { GlobalLocationStateType } from '../types/types';

export default function useDocumentTitle(): void {
  const translate = useTranslate();
  const { pathname } = useLocation<GlobalLocationStateType>();
  const appName = useCfgParam('appName') || 'MySeptim';
  useEffect(() => {
    // Disabled for now. Maybe will be useful in the future when the app will have more routes.
    // const route = pathname.includes('favourites')
    //   ? translate('favourites')
    //   : pathname.includes('dashboard')
    //     ? translate('dashboards')
    //     : '';
    const route = '';
    document.title = [route, appName].filter((i) => i).join(' | ');
  }, [translate, pathname]);
}
